import Image from "next/image";
import styles from "./cyber-certifications.module.css";

// Public IASME certificates, checked 11 October 2026. Update at renewal.
const CERTIFICATIONS = [
  {
    name: "Cyber Essentials",
    mark: "/certifications/cyber-essentials.png",
    issued: "24 September 2026",
    validUntil: "24 September 2027",
    href: "https://registry.blockmarktech.com/certificates/e8fef5a6-966e-42e1-b81e-40daab244f82/",
  },
  {
    name: "Cyber Essentials Plus",
    mark: "/certifications/cyber-essentials-plus.png",
    issued: "11 October 2026",
    validUntil: "11 October 2027",
    href: "https://registry.blockmarktech.com/certificates/c69b6985-2a24-43e6-8bc1-63a1558c6c22/",
  },
] as const;

export function CyberCertifications({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`${styles.certifications} ${compact ? styles.compact : ""}`}>
      <div className={styles.intro}>
        <p className={styles.label}>Cyber security certifications</p>
        <p className={styles.attribution}>
          {compact ? "Mercury Labs’ legal entity, " : "Mercury Labs, the company behind MLX, holds both certifications through its legal entity, "}
          Mercury Digital Assets Limited. Scope: whole organisation.
        </p>
      </div>
      <ul className={styles.grid} aria-label="Cyber Essentials certificates">
        {CERTIFICATIONS.map((certificate) => (
          <li key={certificate.name}>
            <a href={certificate.href} target="_blank" rel="noopener noreferrer" className={styles.card}>
              <div className={styles.mark}>
                <Image src={certificate.mark} alt="" width={1524} height={1826} sizes={compact ? "60px" : "84px"} className={styles.image} />
              </div>
              <div className={styles.detail}>
                <span className={styles.name}>{certificate.name}</span>
                <span className={styles.status}>Certified</span>
                {!compact && (
                  <span className={styles.dates}>
                    Issued {certificate.issued}<br />
                    Valid until {certificate.validUntil}
                  </span>
                )}
                <span className={styles.verify}>View certificate <span aria-hidden="true">↗</span><span className="sr-only"> (opens in a new tab)</span></span>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
